@let blok = responsiveBlok();
@let appearance = blok.appearance;
@let currentTariff = tariffStore.tariff$();
@let currentSize = tariffStore.size$();

<ng-template let-size="size" #sizeHeader>
    <div class="z-10 bg-white !rounded-none md:!rounded-t-lg"
         [class.md:bg-accent]="size === blok.topsellerTariff">
        <!-- topseller -->
        @if (size === blok.topsellerTariff) {
            <div
                class="bg-accent rounded-t-lg max-[340px]:text-xs text-sm sm:text-base text-center max-[340px]:p-[12px] p-[10px] sm:p-[8px]">
                {{ blok.topsellerText }}
            </div>
        }
        @if (((size | indexToTariffEntry:blok.secondaryBannerTextBasic:blok.secondaryBannerTextComfort:blok.secondaryBannerTextPremium)?.length || 0) > 0) {
            <div class="bg-grey90 rounded-t-lg text-center text-sm sm:text-base p-1 hidden md:block">
                {{ size | indexToTariffEntry:blok.secondaryBannerTextBasic:blok.secondaryBannerTextComfort:blok.secondaryBannerTextPremium }}
            </div>
        }
        <button
            class="text-center bg-primary10 p-4 block w-full md:rounded-none"
            [class.is-selected]="size === tariffStore.size$()"
            [class.is-topseller]="size === blok.topsellerTariff"
            [class.rounded-tl-lg]="size === 'basic'"
            [class.rounded-tr-lg]="size === 'premium'"
            [class.md:rounded-t-lg]="size !== blok.topsellerTariff && !(size | indexToTariffEntry:blok.secondaryBannerTextBasic:blok.secondaryBannerTextComfort:blok.secondaryBannerTextPremium)?.length"
            (click)="tariffStore.selectSize(size)"
            [tabindex]="-1">
            <p class="text-inherit text-lg sm:text-2xl md:text-4xl font-light mb-4 md:mb-6 app-ellipsis">
                {{ size | indexToTariffEntry: blok.basicText : blok.comfortText : blok.premiumText }}
            </p>
            <p class="text-inherit text-xl sm:text-3xl md:text-5xl mb-1 app-ellipsis font-bold">
                {{ size | tariffPrice: currentTariff }}
            </p>
            <p class="text-sm sm:text-lg text-light app-ellipsis">
                im Monat
            </p>
            <a app-tariff-size-button
               (click)="selectTariff($event, tariffStore.tariff, tariffStore.size)"
               [routerLink]="(currentTariff === 'family' ? (size | indexToTariffEntry:blok.linkFamilyBasic?.cached_url:blok.linkFamilyComfort?.cached_url:blok.linkFamilyPremium?.cached_url) : (size | indexToTariffEntry:blok.linkSingleBasic?.cached_url:blok.linkSingleComfort?.cached_url:blok.linkSinglePremium?.cached_url)) | sbRouterLink | cachedUrlResolver"
               class="hidden md:flex"
               [priceContent]="size | tariffPrice: currentTariff"
               [topsellerText]="blok.topsellerText"
               [topsellerTariff]="blok.topsellerTariff"
               [tariffSize]="size"
               [disabled]="!currentTariff || !currentSize"
               [title]="!currentTariff || !currentSize ? blok.makeSelectionText : blok.selectText ">
                {{ !currentTariff || !currentSize ? blok.makeSelectionText : blok.selectText }}
            </a>
        </button>
    </div>
</ng-template>

@if (appearance === '3-columns') {
    <div [class]="baseClass + '--selection-mobile'"
         [class.hidden]="!currentTariff"
         class="md:hidden pb-12">
        @for (index of [0, 1, 2]; track index) {
            <a app-tariff-size-button
               (click)="selectTariff($event, tariffStore.tariff, tariffStore.size)"
               [routerLink]="(currentTariff === 'family' ? (index | indexToTariffEntry:blok.linkFamilyBasic?.cached_url:blok.linkFamilyComfort?.cached_url:blok.linkFamilyPremium?.cached_url) : (index | indexToTariffEntry:blok.linkSingleBasic?.cached_url:blok.linkSingleComfort?.cached_url:blok.linkSinglePremium?.cached_url)) | sbRouterLink | cachedUrlResolver"
               [disabled]="!currentTariff || !currentSize"
               [priceContent]="(index | indexToTariffSize) | tariffPrice: currentTariff"
               [topsellerText]="blok.topsellerText"
               [topsellerTariff]="blok.topsellerTariff"
               [tariffSize]="index | indexToTariffSize"
               [title]=" index | indexToTariffEntry:blok.chooseBasic:blok.chooseComfort:blok.choosePremium ">
                {{ index | indexToTariffEntry:blok.chooseBasic:blok.chooseComfort:blok.choosePremium }}
            </a>
        }
    </div>
    <table class="table-fixed w-full border-separate md:border-spacing-x-4 border-spacing-y-0 table">
        <thead>
        <tr>
            @for (index of [0, 1, 2]; track index) {
                <th class="align-bottom">
                    <ng-container *ngTemplateOutlet="sizeHeader; context: { size: index | indexToTariffSize }" />
                </th>
            }
        </tr>
        </thead>
        <tbody>
        <tr class="hidden md:table-row">
            @for (index of [0, 1, 2]; track index) {
                <td class="p-0 align-top bg-primary10" [class.is-selected]="(index  | indexToTariffSize ) === tariffStore.size$()"
                    [class.is-topseller]="(index | indexToTariffSize) === blok.topsellerTariff">
                    <div class="h-full w-full ">
                        @for (child of $any(blok.sections) | filterTariffSectionForSize: (index | indexToTariffSize); track child['_uid']) {
                            <div class="bg-primary10 md:bg-transparent flex-1">
                                <app-tariff-section
                                    [block]="child"
                                    [size]="index | indexToTariffSize"
                                    [appearance]="appearance"
                                    [tariff]="currentTariff"
                                    [selectedIcon]="blok.selectedIcon!"
                                    [selectedIconActive]="blok.selectedIconActive!"
                                    [unselectedIcon]="blok.unselectedIcon!"
                                    [topsellerTariff]="blok.topsellerTariff"
                                    [topsellerText]="blok.topsellerText"
                                />
                            </div>
                        }
                    </div>
                </td>
            }
        </tr>
            @for (child of blok.sections; track child['_uid']) {
                <tr class="md:hidden">
                    <td colspan="3">
                        <app-tariff-section
                            [block]="child"
                            [appearance]="blok.appearance || '3-columns'"
                            [tariff]="currentTariff"
                            [selectedIcon]="blok.selectedIcon!"
                            [selectedIconActive]="blok.selectedIconActive!"
                            [unselectedIcon]="blok.unselectedIcon!"
                            [topsellerTariff]="blok.topsellerTariff"
                            [topsellerText]="blok.topsellerText"
                        />
                    </td>
                </tr>
            }
        </tbody>
    </table>
} @else {
    <table class="table table-fixed w-full">
        <thead>
        <tr>
            <th></th>
            @for (index of [0, 1, 2]; track index) {
                <th class="border-primary align-bottom">
                    <ng-container *ngTemplateOutlet="sizeHeader; context: { size: index | indexToTariffSize }" />
                </th>
            }
        </tr>
        </thead>
        <tbody>
            @for (child of blok.sections; track child['_uid']) {
                <tr>
                    <td colspan="4">
                        <div
                            [class]="baseClass + '--section'"
                            class="bg-primary10 md:bg-transparent align-bottom"
                        >
                            <app-tariff-section
                                [block]="child"
                                [appearance]="blok.appearance || '3-columns'"
                                [tariff]="currentTariff"
                                [selectedIcon]="blok.selectedIcon!"
                                [selectedIconActive]="blok.selectedIconActive!"
                                [unselectedIcon]="blok.unselectedIcon!"
                                [topsellerTariff]="blok.topsellerTariff"
                                [topsellerText]="blok.topsellerText"
                            />
                        </div>
                    </td>
                </tr>
            }
        </tbody>
    </table>
}











